// extracted by mini-css-extract-plugin
export default {"Image":"Header_Image__dXUqD"};